import axiosInstance from "./axiosInstance";

export const createContact = (payload) => {
  return axiosInstance.post("/contact-us", payload);
};
